import { Box } from '@mui/material';
import React from 'react';

const SectionTitle = ({ children, styles = {}, ...rest }) => {
  return (
    <Box
      sx={{
        borderBottom: (theme) => `1px solid ${theme.palette.secondary.main}`,
        paddingBottom: '8px',
        marginBottom: '8px',
        fontWeight: 700,
        ...styles,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default SectionTitle;
